import { render } from "./pekerjaan-list-virtual-scroll.vue?vue&type=template&id=3ab8ea9d"
import script from "./pekerjaan-list-virtual-scroll.vue?vue&type=script&lang=js"
export * from "./pekerjaan-list-virtual-scroll.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__